import moment from "moment";

/**
 * The day a pay-later booking is to be paid by.
 *
 * ponytail: the backend has no pay-by date yet (1NOW-11156 asks for one with the
 * Reserved page's endpoint). Until a booking carries `payment_due_date`, this is
 * the day before pick-up, which is what the approved mockup shows (pick-up
 * Oct 10, "pay by Oct 9"). One function, so the day the field exists it is the
 * only place that changes.
 */
export const payByDate = (booking: any, pickUp?: Date | string | null): moment.Moment | null => {
  const given = booking?.payment_due_date;
  if (given) return moment.parseZone(given);
  const start = booking?.pick_up_time ?? pickUp;
  if (!start) return null;
  const m = typeof start === "string" ? moment.parseZone(start) : moment(start);
  return m.isValid() ? m.clone().subtract(1, "day") : null;
};

/** "Thu, Oct 9", or "" when there is no date. */
export const payByText = (booking: any, pickUp?: Date | string | null): string =>
  payByDate(booking, pickUp)?.format("ddd, MMM D") ?? "";
